import React from 'react';
import { Box, Typography } from '@mui/material';
import { ProvenanceTab, ProvenanceSectionId } from '../wizard/ProvenanceTab';

interface ProvenanceStepProps {
  catalogItemId?: string;
  ownerId?: string | null;
  itemStatus?: string;
}

const SECTIONS: ReadonlySet<ProvenanceSectionId> = new Set<ProvenanceSectionId>([
  'provenance-records',
]);

const PROVENANCE_NOTE_LINES = [
  'Record the ownership history of the object. The Provenance can be public or private depending on the permissions. The Private Only Provenance is always private.',
  '',
  'An example of an entry is',
  'Provenance: Sold to private collector',
  'Private: Sold to David for $25k',
];

/**
 * Renders the chain-of-ownership accordion only; exhibitions, publications,
 * awards, and related-works are promoted to their own top-level steps.
 */
export const ProvenanceStep: React.FC<ProvenanceStepProps> = ({
  catalogItemId,
  ownerId,
  itemStatus,
}) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
    <Typography
      variant="body2"
      color="text.secondary"
      data-testid="provenance-step-note"
      component="div"
    >
      {PROVENANCE_NOTE_LINES.map((line, i) =>
        line === '' ? <br key={i} /> : <div key={i}>{line}</div>
      )}
    </Typography>
    <ProvenanceTab
      catalogItemId={catalogItemId}
      ownerId={ownerId}
      itemStatus={itemStatus}
      visibleSections={SECTIONS}
      flatSections
    />
  </Box>
);
